import React from 'react';

import { useIntl } from 'react-intl';

import Headings from 'components/Headings';
import Message from 'components/Message';
import NestedLink from 'components/NestedLink';
import Typography from 'components/Typography';

import { useTracking } from 'hooks/useTracking';

import { ExploreByOptionInterface, getExploreByOptions } from '../helper';

import './style.scss';

interface ExploreByOptionProps {
  option: ExploreByOptionInterface;
}

const ExploreByOption = ({ option }: ExploreByOptionProps) => {
  const { trackContentInteraction } = useTracking();
  const { formatMessage } = useIntl();

  return (
    <NestedLink
      to={option.link}
      className="ExploreByOption"
      onClick={() => {
        trackContentInteraction(
          'click',
          'explore-by-tiles',
          `explore-by-tiles_${formatMessage(option.text)}`,
        );
      }}
    >
      <Typography className="ExploreByOption__body" variant="body">
        <Message message={option.text} />
      </Typography>
    </NestedLink>
  );
};

const ExploreBy = () => {
  const { locale } = useIntl();

  return (
    <div className="ExploreBy">
      <Headings
        title={{ id: 'components.ExploreBy.title' }}
        config={{ titleAlignCenter: false }}
      />
      <div className="ExploreBy__options">
        {getExploreByOptions(locale).map((option) => (
          <div
            key={option.text.id}
            className="ExploreByOptionWrapper"
            style={{
              backgroundImage: `url("${option.image}")`,
            }}
          >
            <ExploreByOption option={option} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExploreBy;
